"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingPlaceholder = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var react_content_loader_1 = require("react-content-loader");

var __1 = require("../");

var utils_1 = require("../../utils");

function LoadingPlaceholder(_a) {
  var colspan = _a.colspan,
      width = _a.width,
      height = _a.height,
      variant = _a.variant;
  var theme = styled_components_1.useTheme();
  var loaderWidth = width ? width / 2 : 0;
  var minimumHeight = 400;
  var containerHeight = height > minimumHeight ? height - 1 : minimumHeight;
  var themeStyles = utils_1.getComponentThemeStyles(theme, 'ResponsiveTableContainer', variant, 'default');
  return React.createElement(__1.Block, {
    as: "td",
    colspan: colspan,
    height: containerHeight,
    width: width,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, React.createElement(react_content_loader_1.default, {
    style: {
      height: 200,
      padding: 20
    },
    height: 200,
    width: loaderWidth,
    speed: 2,
    primaryColor: themeStyles.loadingPrimaryColor,
    secondaryColor: themeStyles.loadingSecondaryColor
  }, React.createElement("rect", {
    x: "0",
    y: "13",
    rx: "4",
    ry: "4",
    width: loaderWidth,
    height: "20"
  }), React.createElement("rect", {
    x: "40",
    y: "45",
    rx: "4",
    ry: "4",
    width: loaderWidth * 0.5,
    height: "18"
  }), React.createElement("rect", {
    x: "0",
    y: "73",
    rx: "4",
    ry: "4",
    width: loaderWidth * 0.8,
    height: "15"
  }), React.createElement("rect", {
    x: "20",
    y: "98",
    rx: "4",
    ry: "4",
    width: loaderWidth * 0.7,
    height: "18"
  }), React.createElement("rect", {
    x: "40",
    y: "125",
    rx: "4",
    ry: "4",
    width: loaderWidth * 0.8,
    height: "18"
  }), React.createElement("rect", {
    x: "80",
    y: "155",
    rx: "4",
    ry: "4",
    width: loaderWidth * 0.3,
    height: "15"
  }), React.createElement("rect", {
    x: "10",
    y: "180",
    rx: "4",
    ry: "4",
    width: loaderWidth * 0.95,
    height: "18"
  })));
}

exports.LoadingPlaceholder = LoadingPlaceholder;
exports.default = LoadingPlaceholder;